<script>

import { HorizontalBar } from 'vue-chartjs'
import ChartJsPluginDataLabels from 'chartjs-plugin-datalabels'

export default {
  extends: HorizontalBar,
  components: {
    ChartJsPluginDataLabels
  },
  props: {
    affiliations: {
      type: Array
    },
    height: {
      type: Number, default: 350
    },
    blurry: {
      type: Boolean, default: false
    }
  },
  name: 'TopAffiliations',
  watch: {
    affiliations: function (val, oldVal) {
      if (JSON.stringify(val) !== JSON.stringify(oldVal)) {
        this.init()
      }
    }
  },
  data () {
    return {
      blurDisplay: false,
      labels: [],
      dataCmp: [],
      dataUniv: [],
      chart: null,
      colors: ['#33b2df', '#04AE70', '#d4526e', '#13d8aa', '#A5978B', '#f9a3a4', '#69d2e7', '#90ee7e', '#2b908f', '#f48024' ],
      colorCompany: '#3498db', // 'rgba(255, 0, 0, 0.5)',
      colorUniversity: 'rgb(141, 216, 105)', // 'rgba(153, 208, 245, 0.5)',
      nbItems: 5,
      options: {
        responsive: true,
        maintainAspectRatio: false,

        legend: {
          onHover: function (e) {
            e.target.style.cursor = 'pointer'
          }
        },
        hover: {
          onHover: function (e) {
            var point = this.getElementAtEvent(e)
            if (point.length) e.target.style.cursor = 'pointer'
            else e.target.style.cursor = 'default'
          }
        },
        elements: { point: { radius: 0 } },
        plugins: { // Look at this bit
          datalabels: {
            anchor: function (context) {
              var value = context.dataset.data[context.dataIndex]
              return value < 2 ? 'end' : 'center'
            },
            align: function (context) {
              var value = context.dataset.data[context.dataIndex]
              return value < 2 ? 'end' : 'center'
            },
            color: function (context) {
              var value = context.dataset.data[context.dataIndex]
              return value < 2 ? '#ccc' : '#fff'
            },
            formatter: (value, opt) => {
              return value > 0 ? this.truncateString(this.labels[opt.dataIndex], 20) : ''
            },
            offset: 3,
            padding: 3,
            textAnchor: 'start',
            style: {
              colors: ['#fff']
            },
            offsetX: 0,
            dropShadow: {
              enabled: true
            }
          }
        },
        tooltips: {
          enabled: true,
          callbacks: {
            label: function (context, data) {
              let item = data.datasets[context.datasetIndex].data[context.index]
              return item.name
            }
          }
        },
        scales: {
          yAxes: [{
            stacked: true,
            ticks: {
              display: false,
              mirror: true
            },
            scaleLabel: {
              display: true,
              labelString: 'affiliations',
              color: 'rgba(255,99,132,0.2)'
            }
          }],
          xAxes: [{
            stacked: true,
            ticks: {
              stepSize: 1,
              display: false,
              mirror: true,
              min: 0
            },
            scaleLabel: {
              display: true
            }
          }]
        }
      }
    }
  },
  methods: {
    init: function () {
      this.labels = []
      this.data = []
      let nbCompanies = 0
      let nbUniversity = 0
      let dataColor = []
      let affTmp = Object.assign([], this.affiliations)

      affTmp.sort((aff1, aff2) => {
        return aff2.nb - aff1.nb
      })

      affTmp.every((affiliation) => {
        if (affiliation.name !== 'Undefined' && affiliation.name) {
          if (this.checkIsUniversity(affiliation) === false && nbCompanies < this.nbItems) {
            ++nbCompanies
            dataColor.push(this.colorCompany)
            this.labels.push(affiliation.name)
            this.dataCmp.push(affiliation.nb)
            this.dataUniv.push(0)
          } else if (this.checkIsUniversity(affiliation) === true && nbUniversity !== this.nbItems) {
            ++nbUniversity
            dataColor.push(this.colorUniversity)
            this.labels.push(affiliation.name)
            this.dataUniv.push(affiliation.nb)
            this.dataCmp.push(0)
          }
        }
        return !(nbCompanies === this.nbItems && nbUniversity === this.nbItems)
      })
    },
    resize: function () {
      document.getElementById('horizontalbar-chart').style.height = this.height + 'px'
    },
    checkIsUniversity: function (affiliation) {
      let isUniversity = (typeof affiliation.isUniversity === 'boolean' && affiliation.isUniversity === true) ||
        affiliation.isUniversity === 1 ||
        (affiliation.name.toLowerCase().match(/schneider|instr/) === null && affiliation.name.toLowerCase().match(/institute|inst|university|univ|school|national\sresearch|cnrs|centre\snational|college|ecole|faculdade|campus/) !== null)

      return isUniversity
    },
    truncateString: function (str, num) {
      if (typeof str !== 'undefined' && str.length > num) {
        return str.slice(0, num) + ' ...'
      } else {
        return str
      }
    },
    draw: function () {
      this.renderChart({
        labels: this.labels,
        datasets: [
          {
            label: 'Companies',
            backgroundColor: this.colorCompany,
            data: this.dataCmp,
            fill: false
          }, {
            label: 'Universities',
            backgroundColor: this.colorUniversity,
            data: this.dataUniv,
            fill: false
          }
        ]
      }, this.options)

      this.resize()

      if ($('#noDataTopAffiliation').length !== 0) {
        $('#noDataTopAffiliation').remove()
      }

      if (this.blurry === true && this.blurDisplay === false) {
        document.getElementById('horizontalbar-chart').style.filter = 'blur(8px)'

        let blurDiv = document.createElement('div')
        blurDiv.textContent = 'Data not visible for free account'
        blurDiv.style.position = 'absolute'
        blurDiv.style.top = '150px'
        blurDiv.style.width = '100%'
        blurDiv.className = 'text-center'

        this.$el.append(blurDiv)
        this.blurDisplay = true
      } else if (this.dataCmp.length === 0 && this.dataUniv.length === 0) {
        let div = document.createElement('div')

        div.textContent = 'no data'
        div.style.position = 'absolute'
        div.style.top = '150px'
        div.style.width = '100%'
        div.className = 'text-center'
        div.id = 'noDataTopAffiliation'
        this.$el.append(div)
      }
    }
  },
  mounted () {
    this.init()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/charts/TopAffiliations.vue